import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import { AppContext } from "../utilities/context";
import Container from "@mui/material/Container";
import Layout from "./Layout";
import Grid from "@mui/material/Grid";
import "../../public/assets/css/main.css";
import scanningQR from "../../public/assets/images/scanningQR.jpg";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import TelegramIcon from "@mui/icons-material/Telegram";
import QrCodeIcon from "@mui/icons-material/QrCode";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CheckIcon from "@mui/icons-material/Check";

const Home = () => {
  const context = useContext(AppContext);
  const intl = useIntl();

  useEffect(() => {
    if (context) {
      context.updateBreadcrumbsState([]);
    }
  }, []); // The empty dependency array means this effect will only run once (equivalent to componentDidMount)

  return (
    <Layout>
      <Container maxWidth={false} disableGutters>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} sx={{ textAlign: "center" }}>
            <FormattedMessage id="app.home.text" />
          </Grid>
          <Grid item xs={12} md={6} sx={{ textAlign: "center" }}>
            <img src={scanningQR} className={"AppLogoHome"} alt="logo" />
          </Grid>
          <Grid item xs={12} md={6}>
            <List dense={true}>
              <ListItem>
                <ListItemIcon>
                  <PersonAddIcon fontSize="large" color="primary" />
                </ListItemIcon>
                <Link to={"/login"}>
                  <ListItemText
                    primary={intl.formatMessage({
                      id: "app.gettingStarted.step1",
                    })}
                  />
                </Link>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <TelegramIcon fontSize="large" color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary={intl.formatMessage({
                    id: "app.gettingStarted.step2",
                  })}
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <QrCodeIcon fontSize="large" color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary={intl.formatMessage({
                    id: "app.gettingStarted.step3",
                  })}
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <LocationOnIcon fontSize="large" color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary={intl.formatMessage({
                    id: "app.gettingStarted.step4",
                  })}
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <CheckIcon fontSize="large" color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary={intl.formatMessage({
                    id: "app.gettingStarted.step5",
                  })}
                />
              </ListItem>
            </List>
          </Grid>
          <Grid item xs={12} sm={12} sx={{ textAlign: "center" }}>
            <Link to={"mailto:mborches@plopi.com.ar"}>
              <FormattedMessage id="app.home.contact.label" />
            </Link>{" "}|{" "}
            <Link to={"/terms"}>
              <FormattedMessage id="app.terms.title" />
            </Link>{" "}|{" "}
            <Link to={"/privacy"}>
              <FormattedMessage id="app.privacy.title" />
            </Link>

          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};

export default Home;
